import * as React from 'react'

import { EventModel } from '@/app/models/newDelegation/eventModel'

import DelegationMarkerVisual, {
  MARKER_VISUAL_HEIGHT,
  MARKER_VISUAL_WIDTH,
} from './new/DelegationMarkerVisual'

type DelegationMarkerPreviewProps = {
  marker: EventModel
  translate: (text: string) => string
  time?: string
  height?: number
}


const DelegationMarkerPreview: React.FC<DelegationMarkerPreviewProps> = ({
  marker,
  translate,
  time,
  height = MARKER_VISUAL_HEIGHT,
}) => (
  <div style={{ height, width: MARKER_VISUAL_WIDTH }}>
    <DelegationMarkerVisual marker={marker} translate={translate} time={time} />
  </div>
)

export default DelegationMarkerPreview
